import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Sparkles, Calendar } from 'lucide-react';
import { useAppointment } from '../context/AppointmentContext';
import { SERVICE_CATEGORIES } from '../data/services';

const Services = ({ isPreview = false }) => {
  const { servicesList } = useAppointment();
  const [lang, setLang] = useState('en');

  const activeCategories = (servicesList && servicesList.length > 0) ? servicesList : SERVICE_CATEGORIES;

  const displayedCategories = isPreview
    ? activeCategories.slice(0, 1).map(cat => ({
        ...cat,
        services: (cat.services || []).slice(0, 3)
      }))
    : activeCategories;

  return (
    <div className={`appt-page ${isPreview ? 'appt-page-preview' : ''}`}>

      {/* ── Hero (Hidden in Preview) ─────────────────────────────────── */}
      {!isPreview && (
        <div className="appt-hero">
          <div className="appt-hero-badge">
            <Sparkles size={16} />
            <span>{lang === 'en' ? 'Services Offered' : 'सेवाहरू'}</span>
          </div>
          <h1 className="appt-hero-title">
            {lang === 'en' ? <>Sacred <span>Services</span></> : <>पवित्र <span>सेवाहरू</span></>}
          </h1>
          <p className="appt-hero-sub">
            {lang === 'en'
              ? 'Rooted in Vedic tradition — serving the Hindu community in Australia and beyond.'
              : 'वैदिक परम्परामा आधारित — अस्ट्रेलिया र विश्वभरका हिन्दू समुदायको सेवामा।'}
          </p>
          {/* Language Toggle */}
          <div className="svc-lang-toggle">
            <button
              onClick={() => setLang('en')}
              className={`svc-lang-btn ${lang === 'en' ? 'active' : ''}`}
              id="svc-lang-en"
            >
              English
            </button>
            <button
              onClick={() => setLang('np')}
              className={`svc-lang-btn ${lang === 'np' ? 'active' : ''}`}
              id="svc-lang-np"
            >
              नेपाली
            </button>
          </div>
        </div>
      )}

      <div className="appt-container">

        {/* ── Category Sections ─────────────────────────────────────── */}
        {displayedCategories.map((cat) => {
          const catLabel = cat[lang].label;
          const catIcon  = cat[lang].icon;

          return (
            <div key={cat.id} className="appt-card appt-fade-in">
              {/* Category Header */}
              <div className="appt-card-header svc-cat-header" style={{ borderBottomColor: cat.border }}>
                <div
                  className="svc-cat-icon"
                  style={{ background: cat.bg, border: `1.5px solid ${cat.border}` }}
                >
                  <span style={{ fontSize: '1.3rem' }}>{catIcon}</span>
                </div>
                <div>
                  <h3 className="svc-cat-title" style={{ color: cat.color }}>{catLabel}</h3>
                  <p className="svc-cat-count">
                    {cat.services.length} {lang === 'en' ? 'Services' : 'सेवाहरू'}
                  </p>
                </div>
              </div>

              {/* Services Grid */}
              <div className="svc-grid">
                {cat.services.map((svc, idx) => {
                  const t = svc[lang];
                  return (
                    <div
                      key={svc.id}
                      className="svc-card"
                      style={{ background: cat.bg, border: `1.5px solid ${cat.border}` }}
                    >
                      <span className="svc-card-num" style={{ color: cat.color }}>
                        {String(idx + 1).padStart(2, '0')}
                      </span>
                      <h4 className="svc-card-title" style={{ color: cat.color }}>{t.title}</h4>
                      <p className="svc-card-subtitle">{t.subtitle}</p>
                      <p className="svc-card-desc">{t.desc}</p>
                      <div className="svc-card-footer">
                        <Link
                          to="/appointment"
                          className="svc-book-btn"
                          style={{ background: cat.color }}
                        >
                          {lang === 'en' ? 'Book Now' : 'बुक गर्नुहोस्'}
                          <ArrowRight size={13} />
                        </Link>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}

        {/* See More Services Button for MainPage Preview */}
        {isPreview && (
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px', marginBottom: '40px' }}>
            <Link to="/services" className="appt-btn-primary" style={{ display: 'inline-flex', padding: '12px 28px', borderRadius: '12px', textDecoration: 'none' }}>
              See More Services
            </Link>
          </div>
        )}

        {/* ── Bottom CTA Banner (Hidden in Preview) ───────────────────── */}
        {!isPreview && (
          <div className="svc-cta-banner appt-fade-in">
            <div>
              <h3 className="svc-cta-title">
                {lang === 'en' ? 'Ready to Book a Service?' : 'सेवा बुक गर्न तयार हुनुहुन्छ?'}
              </h3>
              <p className="svc-cta-sub">
                {lang === 'en'
                  ? 'Contact Prakash Upadhyaya directly or book an appointment online.'
                  : 'प्रकाश उपाध्यायसँग सिधै सम्पर्क गर्नुहोस् वा अनलाइन अपोइन्टमेन्ट बुक गर्नुहोस्।'}
              </p>
            </div>
            <div className="svc-cta-btns">
              <Link to="/appointment" className="appt-btn-primary" id="svc-cta-book">
                <Calendar size={16} />
                {lang === 'en' ? 'Book Appointment' : 'अपोइन्टमेन्ट बुक गर्नुहोस्'}
              </Link>
              <Link to="/contact" className="svc-cta-outline" id="svc-cta-contact">
                {lang === 'en' ? 'Contact Us' : 'सम्पर्क गर्नुहोस्'}
              </Link>
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default Services;
